import { ReportDataResponse } from "dto";

export class ReportSelection {

  report: ReportDataResponse;

  isSelected: boolean = false;
}
